import type { ModerationConfirmKind, ModerationConfirmState } from '../types';

interface ModerationConfirmTextsConfig {
    titleKey: string;
    descriptionKey: string;
    confirmButtonLabelKey: string;
    titleParams?: Record<string, string>;
}

const MODERATION_CONFIRM_TEXTS: Record<ModerationConfirmKind, Omit<ModerationConfirmTextsConfig, 'titleParams'>> = {
    MUTE_OTHERS_AUDIO: {
        titleKey: 'web_videoconference_moderator_mute_all_except_user_title',
        descriptionKey: 'web_videoconference_moderator_mute_all_except_user_description',
        confirmButtonLabelKey: 'web_videoconference_moderator_button_mute_action',
    },
    MUTE_OTHERS_VIDEO: {
        titleKey: 'web_videoconference_moderator_stop_video_all_except_user_title',
        descriptionKey: 'web_videoconference_moderator_stop_video_all_except_user_description',
        confirmButtonLabelKey: 'web_videoconference_moderator_button_stop_action',
    },
    KICK: {
        titleKey: 'web_videoconference_moderator_remove_from_meeting_action_title',
        descriptionKey: 'web_videoconference_moderator_remove_user_confirm_description',
        confirmButtonLabelKey: 'web_videoconference_moderator_button_remove_action',
    },
    MAKE_MODERATOR: {
        titleKey: 'web_videoconference_moderator_make_moderator',
        descriptionKey: 'moderator_confirm_assign_moderator_role',
        confirmButtonLabelKey: 'web_videoconferencemoderator_button_make_action',
    },
};

/**
 * Получает тексты для модального окна подтверждения модерации
 */
export const getModerationConfirmTexts = (
    confirm: ModerationConfirmState,
    t: (key: string, options?: Record<string, string | number>) => string,
): { title: string; description: string; confirmButtonLabel: string } => {
    if (!confirm) {
        return { title: '', description: '', confirmButtonLabel: '' };
    }

    const config = MODERATION_CONFIRM_TEXTS[confirm.kind];
    const titleParams = ['MUTE_OTHERS_AUDIO', 'MUTE_OTHERS_VIDEO', 'MAKE_MODERATOR'].includes(confirm.kind)
        ? { '0': confirm.targetName }
        : undefined;
    const descriptionParams = confirm.kind === 'MAKE_MODERATOR' ? { '0': confirm.targetName } : undefined;
    return {
        title: titleParams ? t(config.titleKey, titleParams) : t(config.titleKey),
        description: descriptionParams ? t(config.descriptionKey, descriptionParams) : t(config.descriptionKey),
        confirmButtonLabel: t(config.confirmButtonLabelKey),
    };
};
